// Decodes the claims payload of a JWT id_token without verifying its
// signature. Verification happens server-side (JWKS) on the next API call
// made with this token; this is only used to populate localStorage fields
// consumed by the UI (name/picture) and session-restore checks.
const decodeIdToken = (idToken: string): Record<string, unknown> => {
  try {
    const payload = idToken.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return {};
  }
};

export default decodeIdToken;
